import { type ApiClientResponse, apiClient, routes } from 'common/services';

export const readAllNotifications = async () =>
  apiClient.post<unknown, ApiClientResponse<unknown>>(routes.notifications.readAll);
